export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return `${value}`;
}

export function kindLabel(kind: string): string {
  if (kind === "channel") return "频道";
  if (kind === "section") return "版块";
  if (kind === "column") return "栏目";
  return "入口";
}